import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'
import { getEnvVariable } from 'src/_shared/utils/env'

interface PageMetaProps {
	title: string
	description: string
	/**
	 * Optional override for the canonical path.
	 * If not provided, it defaults to the current route's pathname.
	 * Should start with a slash (e.g. '/about-us').
	 */
	canonicalPath?: string
}

const PageMeta = ({ title, description, canonicalPath }: PageMetaProps): JSX.Element => {
	const location = useLocation()
	const baseUrl = getEnvVariable('VITE_OG_URL') ?? 'https://www.voltality.io'

	// Remove trailing slash from base URL if present
	const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl

	// Use provided canonicalPath or fall back to current location pathname
	const path = canonicalPath ?? location.pathname

	// Ensure path starts with slash
	const cleanPath = path.startsWith('/') ? path : `/${path}`

	// Construct full canonical URL
	const canonicalUrl = `${cleanBaseUrl}${cleanPath}`

	return (
		<Helmet>
			<title>{title}</title>
			<meta name="description" content={description} />

			{/* Open Graph tags */}
			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			<meta property="og:url" content={canonicalUrl} />

			{/* Canonical Link */}
			<link rel="canonical" href={canonicalUrl} />
		</Helmet>
	)
}

export default PageMeta
